import { Helmet } from "react-helmet-async";
import { useLang } from "../context/LanguageContext";
import { CODE_TO_URL } from "../lib/i18nRouter";

const SITE_NAME = "OPIKJEWELS";
const SITE_BASE = "https://opikjewels.com";
const DEFAULT_OG = "https://images.unsplash.com/photo-1763256614634-7feb3ff79ff3?w=1200&q=80";

// All site locales with their ISO codes + URL slugs
const HREFLANG_LIST = [
  { iso: "en", slug: "en" },
  { iso: "id", slug: "id" },
  { iso: "zh", slug: "cn" },
  { iso: "th", slug: "th" },
  { iso: "ar", slug: "ar" },
];

const Seo = ({
  title,
  description,
  path = "",
  image = DEFAULT_OG,
  ogType = "website",
  jsonLd = null,
  noIndex = false,
}) => {
  const { lang, meta } = useLang();
  const fullTitle = title ? `${title} · ${SITE_NAME}` : `${SITE_NAME} — Luxury Gemstones · Jakarta · Bangkok`;
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  const restPath = cleanPath === "/" ? "" : cleanPath;
  const currentSlug = CODE_TO_URL[lang] || "en";
  const url = `${SITE_BASE}/${currentSlug}${restPath}`;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <html lang={meta?.htmlLang || "en"} dir={meta?.dir || "ltr"} />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* hreflang alternates for all supported languages */}
      {HREFLANG_LIST.map((l) => (
        <link key={l.iso} rel="alternate" hrefLang={l.iso}
          href={`${SITE_BASE}/${l.slug}${restPath}`} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${SITE_BASE}/en${restPath}`} />

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={(meta?.htmlLang || "en").replace("-", "_")} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {/* JSON-LD */}
      {blocks.map((b, i) => {
        const t = b && b["@type"];
        const id = b && b["@id"];
        const key = id || (Array.isArray(t) ? t.join("-") : t) || `ld-${i}`;
        return (
          <script key={key} type="application/ld+json">
            {JSON.stringify(b)}
          </script>
        );
      })}
    </Helmet>
  );
};

export default Seo;
export { SITE_BASE, SITE_NAME };
